import { Component, OnInit, OnDestroy,Injectable } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ShareService} from './../services/services';
import 'rxjs/add/operator/publishReplay';

let headers = new Headers();
headers.append('Access-Control-Allow-Origin', '*');
headers.append('Content-Type', 'application/x-www-form-urlencoded');
let options = new RequestOptions({ headers: headers });	 

export class Banner {
    constructor(public image: string) { }
}

@Injectable()
export class BannerService {

  
    public _banner;
    constructor(
      private http: Http,
      
      private shareService: ShareService) {  
  
    }

	getbanner() {
	    //console.log(slug);
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');
	    ///alert(this.getToken());
	   
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/banner';	 
	   	if (!this._banner) {     
        this._banner = this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);  
         }
             return this._banner;

	}
	
	handleError(error) {
        console.error("Got the error: " + JSON.stringify(error));
        return Observable.throw(error.json().error || 'Banner Server error');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/banner/banner.service.ts